<template>
    <div>
        <div class="collectBox" v-show="chapter == 1">
          <div class="titleBox">
            <div class="titleLeft" @click="returnTopic">
              <!-- <img src="../../assets/images/titleArrow.png" alt="" /> -->
            </div>
            <div class="titleCentre">智能组题</div>
            <div class="titleRight" @click="testCreationClick">组题记录</div>
          </div>
          <div class="formBox">
            <div class="subject">
                <div class="head">
                    <div class="label">学科<span>（可多选）</span></div>
                    <div class="btn" @click="chapterClick()">章节选择</div>
                </div>
                <van-checkbox-group ref="checkboxGroup" v-model="result" direction="horizontal" class="checkbox" @change="checkboxChange">
                  <van-checkbox :class="{'checkbox_active':result.indexOf('all') >= 0}" name="all" @click="checkAll()">全部</van-checkbox>
                  <van-checkbox v-for="item in subjectList" :key="item.id" :class="{'checkbox_active':result.indexOf(item.id) >= 0}" :name="item.id">{{ item.label }}</van-checkbox>
                </van-checkbox-group>
            </div>
            <div class="subject">
                <div class="head">
                    <div class="label">题型<span>（可多选）</span></div>
                    <div class="btn"></div>
                </div>
                <van-checkbox-group ref="questionTypeGroup" v-model="questionTypes" direction="horizontal" class="checkbox" @change="checkboxQuestionTypeChange">
                  <van-checkbox :class="{'checkbox_active':questionTypes.indexOf('all') >= 0}" name="all" @click="checkQuestionTypeAll()">全部</van-checkbox>
                  <van-checkbox v-for="item in questionTypeList" :key="item.id" :class="{'checkbox_active':questionTypes.indexOf(item.id) >= 0}" :name="item.id">{{ item.label }}</van-checkbox>
                </van-checkbox-group>
            </div>
            <div class="classification">
                <div class="head">
                    <div class="label">分类<span>（单选）</span></div>
                    <div class="btn"></div>
                </div>
                <van-radio-group v-model="classificationRadio" direction="horizontal" class="radiobox">
                  <van-radio :class="{'checkbox_active':classificationRadio == '1'}" name="1">未做</van-radio>
                  <van-radio :class="{'checkbox_active':classificationRadio == '2'}" name="2">错题</van-radio>
                  <van-radio :class="{'checkbox_active':classificationRadio == '3'}" name="3">收藏</van-radio>
                </van-radio-group>
            </div>
            <div class="num">
                <div class="head">
                    <div class="label">题量<span>{{`（一共有${unNun}题符合条件，最多可组${maxNum}题）`}}</span></div>
                    <div class="btn"></div>
                </div>
                <van-stepper input-width="80px" button-size="32px" class="stepper" v-model="num" min="0" :max="maxNum" />
            </div>
            <div class="name">
                <div class="head">
                    <div class="label">试卷名称<span></span></div>
                    <div class="btn"></div>
                </div>
                <van-field @focus="keyboard = true" @blur="keyboard = false" v-model="title" label="" placeholder="请输入试卷名称" />
            </div>
          </div>
          <div class="answer">
            <div @click="submitAnswer">开始答题</div>
          </div>
        </div>
        <div class="collectBox" v-show="chapter == 2">
          <div class="titleBox">
            <div class="titleLeft" @click="chapter = 1">
              <!-- <img src="../../assets/images/titleArrow.png" alt="" /> -->
            </div>
            <div class="titleCentre">章节选择</div>
            <div class="titleRight"></div>
          </div>
          <div class="tree">
            <el-tree
              class="tree-border"
              :data="subjectList"
              show-checkbox
              ref="menu"
              node-key="id"
              :check-strictly="false"
              empty-text="暂无数据"
              :props="defaultProps"
            ></el-tree>
          </div>
          <div class="bottomBtn">
            <div class="left">
                <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event)">全选</el-checkbox>
            </div>
            <div class="right" @click="submitMenu">
                确定
            </div>
          </div>
        </div>
    </div>
</template>
  
  <script>
//   import { getNum, getSubjectTree,addAnswer } from "@/api/topic/index.js";
import * as topicApi from "@/api/topic/index.js";
import * as topicsApi from "@/api/topics/index.js";
  export default {
    data() {
      return {
        keyboard: false,
        defaultProps: {
          children: "children",
          label: "label"
        },
        menuNodeAll: false,
        studyBankId: '',
        chapter: 1,
        classificationRadio: '1',
        categoryIds: [],
        title: '',
        num: 0,
        unNun: 0,
        maxNum: 0,
        result: [],
        subjectList: [],
        questionTypes: [],
        flag: true,
        questionTypeList: [
            {
                label: 'A1型题',
                id: 0
            },
            {
                label: 'A2型题',
                id: 1
            },
            {
                label: 'A3型题',
                id: 2
            },
            {
                label: 'A4型题',
                id: 3
            },
            {
                label: 'B型题',
                id: 4
            },
            {
                label: 'X型题',
                id: 5
            },
            {
                label: '判断题',
                id: 6
            },
            {
                label: '填空题',
                id: 7
            },
            {
                label: '问答题',
                id: 8
            },
        ],
      };
    },
    created() {
      this.studyBankId = this.$route.query.studyBankId;
    //   this.studyBankId = '1831234200356986881'
      this.getTreeList();
    },
    computed: {
        // 根据 questionType 返回对应的 API 模块
        api() {
        return this.$route.query.questionType == 1 ? topicApi : topicsApi;
        },
    },
    watch: {
        classificationRadio(val){
            if (this.flag) {
                this.flag = false
                this.getQuestionNum()
                setTimeout(() => {
                    this.flag = true
                }, 300);
            }
        },
        questionTypes(val){
            if (this.flag) {
                this.flag = false
                setTimeout(() => {
                    this.getQuestionNum()
                    this.flag = true
                }, 300);
                // setTimeout(() => {
                //     this.flag = true
                // }, 300);
            }
        },
        result(val){
            if (this.flag) {
                this.flag = false
                setTimeout(() => {
                    this.getQuestionNum()
                    this.flag = true
                }, 300);
                // setTimeout(() => {
                //     this.flag = true
                // }, 300);
            }
        },
    },

    methods: {
            returnTopic() {
      this.$router.push({ path: "/topic",
        query: {
            questionType: this.$route.query.questionType,
         }
       });
    },
        // 组题记录
        testCreationClick() {
            this.$router.push({
                path: "/testCreation",
                query: { 
                    studyBankId: this.studyBankId,
                    questionType: this.$route.query.questionType,
                 },
            });
        },
        submitAnswer(){
            let params = {
                studyBankId: this.studyBankId,
                questionTypes: [],
                type: this.classificationRadio,
                categoryIds: [],
                title: this.title,
                num: this.num,
            }
            if (this.categoryIds && this.categoryIds.length > 0) {
                params.categoryIds = this.categoryIds 
            } else {
                let arr = JSON.parse(JSON.stringify(this.result));
                arr.forEach((item,index) => {
                    if (item == 'all') {
                        arr.splice(index,1)
                    }
                });
                params.categoryIds = arr
            }
            if (this.questionTypes) {
                let arr1 = JSON.parse(JSON.stringify(this.questionTypes));
                arr1.forEach((item,index) => {
                    if (item == 'all') {
                        arr1.splice(index,1)
                    }
                });
                params.questionTypes = arr1
            }
            this.api.addAnswer(params).then((res) => {
                console.log('res',res)
                if(res.code == 200) {
                    this.$router.push({
                    path: "/homework",
                    query: { studyPaperId: res.data,  typeFlag: 5, name: 'groupQuestion', studyBankId: this.studyBankId,questionType: this.$route.query.questionType,},
                    });
                }
            })
        },
        getQuestionNum(){
            console.log(this.result,'this.result');
            console.log(this.questionTypes,'this.questionTypes');
            let params = {
                studyBankId: this.studyBankId,
                questionTypes: [],
                type: this.classificationRadio,
                categoryIds: []
            }
            if (this.categoryIds && this.categoryIds.length > 0) {
                params.categoryIds = JSON.parse(JSON.stringify(this.categoryIds));
            } else {
                let arr = JSON.parse(JSON.stringify(this.result));
                arr.forEach((item,index) => {
                    if (item == 'all') {
                        arr.splice(index,1)
                    }
                });
                params.categoryIds = arr
            }
            if (this.questionTypes) {
                let arr1 = JSON.parse(JSON.stringify(this.questionTypes));
                arr1.forEach((item,index) => {
                    if (item == 'all') {
                        arr1.splice(index,1)
                    }
                });
                params.questionTypes = arr1
            }
            console.log(params,'params');
            this.api.getNum(params).then((res) => {
                if (res.data && res.data > 200) {
                    this.maxNum = 200
                    this.num = 200
                    this.unNun = res.data
                } else {
                    this.maxNum = res.data
                    this.num = res.data
                    this.unNun = res.data
                }
                if (res.data) {
                    if (res.data > 200) {
                        this.maxNum = 200
                        this.num = 200
                    } else {
                        this.maxNum = res.data
                        this.num = res.data
                    }
                    this.unNun = res.data
                } else {
                    this.maxNum = 0
                    this.num = 0
                    this.unNun = 0
                }
                
            })
        },
        submitMenu(){
            let arr1 = this.getMenuAllCheckedKeys();
            let arr2 = this.$refs.menu.getCheckedKeys(true);
            let newArr = [];
            arr1.forEach(item => {
                if (arr2.indexOf(item) < 0) {
                    newArr.push(item);
                }
            });
            if (newArr.length == this.subjectList.length) {
                newArr.push('all')
            }
            this.result = JSON.parse(JSON.stringify(newArr));
            this.categoryIds = this.$refs.menu.getCheckedKeys(true);
            this.chapter = 1;
        },
        // 所有菜单节点数据
        getMenuAllCheckedKeys() {
          // 目前被选中的菜单节点
          let checkedKeys = this.$refs.menu.getCheckedKeys();
          // 半选中的菜单节点
          let halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys();
          checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
          return checkedKeys;
        },
        chapterClick(){
            let arr = [];
            if (this.result.length > 0 && this.result.indexOf('all') >= 0) {
                arr = JSON.parse(JSON.stringify(this.result));
                arr.splice(arr.indexOf('all'),1)
            } else {
                arr = JSON.parse(JSON.stringify(this.result));
            }
            this.$refs.menu.setCheckedKeys(arr);
            this.chapter = 2;
        },
        // 树权限（全选/全不选）
        handleCheckedTreeNodeAll(value) {
            this.$refs.menu.setCheckedNodes(value ? this.subjectList: []);
        },
        async getTreeList() {
          const { data } = await this.api.getSubjectTree(this.studyBankId);
          let arr = data.studyBankCategories
          arr.forEach(item => {
            item.label = item.parentCategoryName
            item.id = item.parentCategoryId
            item.children = item.studyBankCategories
            item.children.forEach(element => {
                element.label = element.categoryName
                element.id = element.categoryId
            });
          });
          this.subjectList = JSON.parse(JSON.stringify(arr));
        //   setTimeout(() => {
        //       this.$refs.checkboxGroup.toggleAll(true);
        //       this.$refs.questionTypeGroup.toggleAll(true);
        //   }, 300);
        },
        checkboxChange(){
            if (this.subjectList.length == this.result.length && this.result.indexOf('all') < 0) {
                this.result.unshift('all');
            }
            if (this.subjectList.length == this.result.length && this.result.indexOf('all') >= 0) {
                this.result.splice(this.result.indexOf('all'),1)
            }
        },
        checkAll(){
            if (this.result.length == this.subjectList.length + 1)  {
                this.$refs.checkboxGroup.toggleAll();
                this.result = []
                return
            }
            if (this.result.indexOf('all') >= 0) {
                this.$refs.checkboxGroup.toggleAll(true);
                return
            } 
            this.$refs.checkboxGroup.toggleAll(true);
        },
        checkboxQuestionTypeChange(){
            if (this.questionTypeList.length == this.questionTypes.length && this.questionTypes.indexOf('all') < 0) {
                this.questionTypes.unshift('all');
            }
            if (this.questionTypeList.length == this.questionTypes.length && this.questionTypes.indexOf('all') >= 0) {
                this.questionTypes.splice(this.questionTypes.indexOf('all'),1)
            }
        },
        checkQuestionTypeAll(){
            if (this.questionTypes.length == this.questionTypeList.length + 1)  {
                this.$refs.questionTypeGroup.toggleAll();
                this.questionTypes = []
                return
            }
            if (this.questionTypes.indexOf('all') >= 0) {
                this.$refs.questionTypeGroup.toggleAll(true);
                return
            } 
            this.$refs.questionTypeGroup.toggleAll(true);
        },
    },
  };
  </script>
  
  
  <style lang="scss" scoped>
  .collectBox {
    padding: 0 16px;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(
      180deg,
      rgba(196, 249, 247, 0.5) 0%,
      rgba(255, 255, 255, 0.5) 135px
    );
    .titleBox {
      padding: 44px 0 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 343px;
      height: 88px;
      margin-bottom: 30px;
      // background-color: salmon;
      .titleLeft {
        width: 20px;
        height: 20px;
        background-image: url("../../assets/images/titleArrow.png");
        background-size: 100%;
        // ../../assets/images/titleArrow.png
        // img {
        //   width: 20px;
        //   height: 20px;
        // }
      }
      .titleCentre {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #121212;
        text-align: center;
        font-style: normal;
        margin-left: 86px;
      }
      .titleRight {
        width: 106px;
        height: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        text-align: right;
        font-style: normal;
      }
    }
    .formBox {
        width: 100%;
        padding-bottom: 108px;
        overflow: auto;
        .subject {
            width: 100%;
            margin-bottom: 15px;
            // height: 136px;
            .head {
                height: 34px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .label {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 17px;
                    color: #121212;
                    line-height: 24px;
                    text-align: left;
                    font-style: normal;
                    span {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 20px;
                        text-align: center;
                        font-style: normal;
                    }
                }
                .btn {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #1BBF8D;
                    line-height: 20px;
                    text-align: center;
                    font-style: normal;
                }
            }
            .checkbox {
                .checkbox_active {
                    background: rgba(27,191,141,0.1) !important;
                    border-radius: 4px;
                    border: 1px solid rgba(27,191,141,0.5);

                    ::v-deep .van-checkbox__label {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        color: #1BBF8D !important;
                    }
                }
                ::v-deep .van-checkbox {
                    justify-content: center;
                }
                ::v-deep .van-checkbox--horizontal {
                    width: 77px;
                    height: 32px;
                    padding: 3px;
                    margin: 0 4px;
                    margin-bottom: 10px;
                    background: #F5F5F5;
                    border-radius: 4px;
                    text-align: center;

                    .van-checkbox__icon {
                        display: none;
                    }
                    .van-checkbox__label {
                        margin: 0;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 20px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        .classification {
            width: 100%;
            margin-bottom: 15px;
            // height: 136px;
            .head {
                height: 34px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .label {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 17px;
                    color: #121212;
                    line-height: 24px;
                    text-align: left;
                    font-style: normal;
                    span {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 20px;
                        text-align: center;
                        font-style: normal;
                    }
                }
                .btn {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #1BBF8D;
                    line-height: 20px;
                    text-align: center;
                    font-style: normal;
                }
            }
            .radiobox {
                .checkbox_active {
                    background: rgba(27,191,141,0.1) !important;
                    border-radius: 4px;
                    border: 1px solid rgba(27,191,141,0.5);

                    ::v-deep .van-radio__label {
                        color: #1BBF8D !important;
                    }
                }
                ::v-deep .van-radio {
                    justify-content: center;
                }
                ::v-deep .van-radio--horizontal {
                    width: 77px;
                    height: 32px;
                    padding: 3px;
                    margin: 0 4px;
                    margin-bottom: 10px;
                    background: #F5F5F5;
                    border-radius: 4px;
                    text-align: center;

                    .van-radio__icon {
                        display: none;
                    }
                    .van-radio__label {
                        margin: 0;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 20px;
                    }
                }
            }
        }
        .num {
            width: 100%;
            margin-bottom: 25px;
            // height: 136px;
            .head {
                height: 34px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .label {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 17px;
                    color: #121212;
                    line-height: 24px;
                    text-align: left;
                    font-style: normal;
                    span {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 20px;
                        text-align: center;
                        font-style: normal;
                    }
                }
                .btn {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #1BBF8D;
                    line-height: 20px;
                    text-align: center;
                    font-style: normal;
                }
            }
            .stepper {
                ::v-deep .van-stepper__minus {
                    display: none;
                }
                ::v-deep .van-stepper__plus {
                    display: none;
                }
                ::v-deep .van-stepper__input {
                    border-radius: 4px;
                    background: #F5F5F5;
                }
            }
        }
        .name {
            width: 100%;
            margin-bottom: 25px;
            // height: 136px;
            .head {
                height: 34px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .label {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 17px;
                    color: #121212;
                    line-height: 24px;
                    text-align: left;
                    font-style: normal;
                    span {
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 20px;
                        text-align: center;
                        font-style: normal;
                    }
                }
                .btn {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #1BBF8D;
                    line-height: 20px;
                    text-align: center;
                    font-style: normal;
                }
            }
            ::v-deep .van-cell {
                border-radius: 4px;
                background: #F5F5F5;
                padding: 7px 12px;
            }
        }
    }
    .answer {
        position: fixed;
        bottom: 0px;
        width: 343px;
        height: 98px;
        div {
            width: 140px;
            height: 48px;
            background: #1BBF8D;
            box-shadow: 0px 3px 10px 0px rgba(27,191,141,0.3);
            border-radius: 24px;
            margin: 0 101px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 48px;
            text-align: center;
            font-style: normal;
        }
    }
    .tree {
        height: 450px;
        overflow: auto;
    }
    .tree-border {
        border: none;
        ::v-deep .el-tree-node__content {
            height: 54px;
            border-bottom: 1px solid #EEEEEE;
            &:hover {
                background-color: #ffffff00;
            }
            .el-tree-node__expand-icon {
                position: absolute;
                right: 10px;
                &.expanded {
                    transform: rotate(180deg);
                }
            }
            .el-icon-caret-right::before {
                content: "\e6df";
                font-size: 18px;
            }
            .el-checkbox {
                .el-checkbox__input {
                    .el-checkbox__inner {
                        border-radius: 50%;
                        height: 16px;
                        width: 16px;
                        &:hover {
                            border-color: #1BBF8D;
                        }
                        &::after {
                            margin-left: 1px;
                            margin-top: 1px;
                        }
                    }
                }
                .is-checked {
                    .el-checkbox__inner {
                        background-color: #1BBF8D;
                        border-color: #1BBF8D;
                    }
                }
                .is-focus {
                    .el-checkbox__inner {
                        border-color: #1BBF8D;
                    }
                }
                .is-indeterminate {
                    .el-checkbox__inner {
                        background-color: #1BBF8D;
                        border-color: #1BBF8D;
                    }
                }
            }
            .el-tree-node__label {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #000000;
                line-height: 22px;
            }
        }
        ::v-deep .el-tree-node__children {
            .el-tree-node__label {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 20px;
            }
        }
    }
    .bottomBtn {
        position: fixed;
        bottom: 38px;
        right: 0px;
        width: 343px;
        height: 44px;
        margin: 0 16px;
        border-radius: 22px;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        .left {
            width: 50%;
            height: 44px;
            background: rgba(27,191,141,0.1);
            display: flex;
            justify-content: center;
            align-items: center;
            ::v-deep .el-checkbox {
                .el-checkbox__label {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #1BBF8D;
                    line-height: 22px;
                    text-align: center;
                }
                .el-checkbox__input {
                    .el-checkbox__inner {
                        border-radius: 50%;
                        height: 16px;
                        width: 16px;
                        border-color: #1BBF8D;
                        &:hover {
                            border-color: #1BBF8D;
                        }
                        &::after {
                            margin-left: 1px;
                            margin-top: 1px;
                        }
                    }
                }
                .is-checked {
                    .el-checkbox__inner {
                        background-color: #1BBF8D;
                        border-color: #1BBF8D;
                    }
                }
                .is-focus {
                    .el-checkbox__inner {
                        border-color: #1BBF8D;
                    }
                }
                .is-indeterminate {
                    .el-checkbox__inner {
                        background-color: #1BBF8D;
                        border-color: #1BBF8D;
                    }
                }
            }
        }
        .right {
            width: 50%;
            height: 44px;
            background: #1BBF8D;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 44px;
            text-align: center;
        }
    }
  }
  </style>